import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { Injectable } from '@angular/core';
import { ICommsEvent } from '../interfaces/comms-event';

@Injectable({
  providedIn: 'root',
})
export class CommsEventService extends BaseDataService {
  url = '/api/commsEvent';
  entityTitle = 'Comms Event';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getCommsEvents(): Promise<ICommsEvent[]> {
    return this.handleRequest<any[]>(
      this.http.get<ICommsEvent[]>(this.url),
      this.handlersFactory.getForReadAll(),
    );
  }

  deleteEvent(id) {
    var newUrl = this.url + '/' + id;

    return this.handleRequest<any>(
      this.http.delete<any>(newUrl),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }

  saveEvent({ commsEvent }) {
    if (commsEvent.id == 0 || commsEvent.id == null) {
      console.log('SAVING');
      console.log(commsEvent);

      return this.handleRequest<any>(
        this.http.post<ICommsEvent>(this.url, commsEvent),
        this.handlersFactory.getForUpdate(this.entityTitle),
      );
    } else {
      var newUrl = this.url + '/' + commsEvent.id;

      return this.handleRequest<any>(
        this.http.put<ICommsEvent>(newUrl, commsEvent),
        this.handlersFactory.getForUpdate(this.entityTitle),
      );
    }
  }
}
